import React from 'react';

import classes from './WidgetHeaderActions.module.scss';
import { LbChip } from '../../../../../../../shared/components/ui-components';
import {
  ModeButtonsBlock,
  ModeButtonsBlockProps,
} from '../../../../../../../shared/components/buttons/ModeButtonsBlock/ModeButtonsBlock';

type WidgetHeaderActionsProps = ModeButtonsBlockProps & {
  isInvalid?: boolean;
};

const WidgetHeaderActions = ({
  mode,
  isInvalid,
  ...modeButtonsBlockProps
}: WidgetHeaderActionsProps) => {
  return (
    <div className={classes.container}>
      {isInvalid && mode === 'VIEW' && (
        <LbChip label="Complete setup" color="error" size="small" />
      )}
      <ModeButtonsBlock mode={mode} {...modeButtonsBlockProps} />
    </div>
  );
};

export { WidgetHeaderActions };
